export enum VisualType {
    Icon = 'ICON',
    Image = 'IMAGE'
}
